import { jsxs as Q, jsx as c, Fragment as se } from "react/jsx-runtime";
import * as s from "react";
import { forwardRef as _ } from "react";
import { a as Se } from "./react-icons.esm-CDi78UIJ.js";
import * as Ie from "react-dom";
import { c as P } from "./index-DLeNytVF.js";
import { u as ne } from "./index-DLcqcWxM.js";
import { c as Ae } from "./index-CUE0gmT0.js";
import { c as Fe } from "./index-UFb2E87s.js";
import { B as _e, R as De } from "./index-Dz0AUfZX.js";
import { P as Le } from "./index-CsGiVPqA.js";
import { P as Me } from "./index-L6dgm95g.js";
import { P as D, d as Oe } from "./index-BrTLHETv.js";
import { u as X } from "./index-DwYXX2sM.js";
import { u as ke } from "./index-DYfkNB0n.js";
import { u as Ve } from "./index-DuekHEmj.js";
import { V as ae } from "./index-DcK06DuQ.js";
import { c as Ke } from "./index-CYpVUGdk.js";
import { $ as L } from "./utils-CTvPli9r.js";
var Z = "ToastProvider", [ee, $e, He] = Ae("Toast"), [ie, St] = Fe("Toast", [He]), [We, Y] = ie(Z), ce = (e) => {
  const {
    __scopeToast: t,
    label: o = "Notification",
    duration: r = 5e3,
    swipeDirection: u = "right",
    swipeThreshold: l = 50,
    children: p
  } = e, [v, w] = s.useState(null), [n, b] = s.useState(0), E = s.useRef(!1), M = s.useRef(!1);
  return o.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${Z}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ c(ee.Provider, { scope: t, children: /* @__PURE__ */ c(
    We,
    {
      scope: t,
      label: o,
      duration: r,
      swipeDirection: u,
      swipeThreshold: l,
      toastCount: n,
      viewport: v,
      onViewportChange: w,
      onToastAdd: s.useCallback(() => b((R) => R + 1), []),
      onToastRemove: s.useCallback(() => b((R) => R - 1), []),
      isFocusedToastEscapeKeyDownRef: E,
      isClosePausedRef: M,
      children: p
    }
  ) });
};
ce.displayName = Z;
var ue = "ToastViewport", Ue = ["F8"], q = "toast.viewportPause", G = "toast.viewportResume", de = s.forwardRef(
  (e, t) => {
    const {
      __scopeToast: o,
      hotkey: r = Ue,
      label: u = "Notifications ({hotkey})",
      ...l
    } = e, p = Y(ue, o), v = $e(o), w = s.useRef(null), n = s.useRef(null), b = s.useRef(null), E = s.useRef(null), M = ne(t, E, p.onViewportChange), R = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), N = p.toastCount > 0;
    s.useEffect(() => {
      const i = (x) => {
        var m;
        r.length !== 0 && r.every((T) => x[T] || x.code === T) && ((m = E.current) == null || m.focus());
      };
      return document.addEventListener("keydown", i), () => document.removeEventListener("keydown", i);
    }, [r]), s.useEffect(() => {
      const i = w.current, x = E.current;
      if (N && i && x) {
        const f = () => {
          if (!p.isClosePausedRef.current) {
            const g = new CustomEvent(q);
            x.dispatchEvent(g), p.isClosePausedRef.current = !0;
          }
        }, m = () => {
          if (p.isClosePausedRef.current) {
            const g = new CustomEvent(G);
            x.dispatchEvent(g), p.isClosePausedRef.current = !1;
          }
        }, T = (g) => {
          !i.contains(g.relatedTarget) && m();
        }, y = () => {
          i.contains(document.activeElement) || m();
        };
        return i.addEventListener("focusin", f), i.addEventListener("focusout", T), i.addEventListener("pointermove", f), i.addEventListener("pointerleave", y), window.addEventListener("blur", f), window.addEventListener("focus", m), () => {
          i.removeEventListener("focusin", f), i.removeEventListener("focusout", T), i.removeEventListener("pointermove", f), i.removeEventListener("pointerleave", y), window.removeEventListener("blur", f), window.removeEventListener("focus", m);
        };
      }
    }, [N, p.isClosePausedRef]);
    const d = s.useCallback(
      ({ tabbingDirection: i }) => {
        const f = v().map((m) => {
          const T = m.ref.current, y = [T, ...ot(T)];
          return i === "forwards" ? y : y.reverse();
        });
        return (i === "forwards" ? f.reverse() : f).flat();
      },
      [v]
    );
    return s.useEffect(() => {
      const i = E.current;
      if (i) {
        const x = (f) => {
          var y, g, S;
          const m = f.altKey || f.ctrlKey || f.metaKey;
          if (f.key === "Tab" && !m) {
            const O = document.activeElement, A = f.shiftKey;
            if (f.target === i && A) {
              (y = n.current) == null || y.focus();
              return;
            }
            const I = d({ tabbingDirection: A ? "backwards" : "forwards" }), $ = I.findIndex((a) => a === O);
            z(I.slice($ + 1)) ? f.preventDefault() : A ? (g = n.current) == null || g.focus() : (S = b.current) == null || S.focus();
          }
        };
        return i.addEventListener("keydown", x), () => i.removeEventListener("keydown", x);
      }
    }, [v, d]), /* @__PURE__ */ Q(
      _e,
      {
        ref: w,
        role: "region",
        "aria-label": u.replace("{hotkey}", R),
        tabIndex: -1,
        style: { pointerEvents: N ? void 0 : "none" },
        children: [
          N && /* @__PURE__ */ c(
            J,
            {
              ref: n,
              onFocusFromOutsideViewport: () => {
                const i = d({
                  tabbingDirection: "forwards"
                });
                z(i);
              }
            }
          ),
          /* @__PURE__ */ c(ee.Slot, { scope: o, children: /* @__PURE__ */ c(D.ol, { tabIndex: -1, ...l, ref: M }) }),
          N && /* @__PURE__ */ c(
            J,
            {
              ref: b,
              onFocusFromOutsideViewport: () => {
                const i = d({
                  tabbingDirection: "backwards"
                });
                z(i);
              }
            }
          )
        ]
      }
    );
  }
);
de.displayName = ue;
var le = "ToastFocusProxy", J = s.forwardRef(
  (e, t) => {
    const { __scopeToast: o, onFocusFromOutsideViewport: r, ...u } = e, l = Y(le, o);
    return /* @__PURE__ */ c(
      ae,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...u,
        ref: t,
        style: { position: "fixed" },
        onFocus: (p) => {
          var n;
          const v = p.relatedTarget;
          !((n = l.viewport) != null && n.contains(v)) && r();
        }
      }
    );
  }
);
J.displayName = le;
var K = "Toast", Xe = "toast.swipeStart", Ye = "toast.swipeMove", je = "toast.swipeCancel", Be = "toast.swipeEnd", pe = s.forwardRef(
  (e, t) => {
    const { forceMount: o, open: r, defaultOpen: u, onOpenChange: l, ...p } = e, [v, w] = ke({
      prop: r,
      defaultProp: u ?? !0,
      onChange: l,
      caller: K
    });
    return /* @__PURE__ */ c(Me, { present: o || v, children: /* @__PURE__ */ c(
      Ge,
      {
        open: v,
        ...p,
        ref: t,
        onClose: () => w(!1),
        onPause: X(e.onPause),
        onResume: X(e.onResume),
        onSwipeStart: P(e.onSwipeStart, (n) => {
          n.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: P(e.onSwipeMove, (n) => {
          const { x: b, y: E } = n.detail.delta;
          n.currentTarget.setAttribute("data-swipe", "move"), n.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${b}px`), n.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${E}px`);
        }),
        onSwipeCancel: P(e.onSwipeCancel, (n) => {
          n.currentTarget.setAttribute("data-swipe", "cancel"), n.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), n.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), n.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), n.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: P(e.onSwipeEnd, (n) => {
          const { x: b, y: E } = n.detail.delta;
          n.currentTarget.setAttribute("data-swipe", "end"), n.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), n.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), n.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${b}px`), n.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${E}px`), w(!1);
        })
      }
    ) });
  }
);
pe.displayName = K;
var [ze, qe] = ie(K, {
  onClose() {
  }
}), Ge = s.forwardRef(
  (e, t) => {
    const {
      __scopeToast: o,
      type: r = "foreground",
      duration: u,
      open: l,
      onClose: p,
      onEscapeKeyDown: v,
      onPause: w,
      onResume: n,
      onSwipeStart: b,
      onSwipeMove: E,
      onSwipeCancel: M,
      onSwipeEnd: R,
      ...N
    } = e, d = Y(K, o), [i, x] = s.useState(null), f = ne(t, (a) => x(a)), m = s.useRef(null), T = s.useRef(null), y = u || d.duration, g = s.useRef(0), S = s.useRef(y), O = s.useRef(0), { onToastAdd: A, onToastRemove: j } = d, F = X(() => {
      var h;
      (i == null ? void 0 : i.contains(document.activeElement)) && ((h = d.viewport) == null || h.focus()), p();
    }), I = s.useCallback(
      (a) => {
        !a || a === 1 / 0 || (window.clearTimeout(O.current), g.current = (/* @__PURE__ */ new Date()).getTime(), O.current = window.setTimeout(F, a));
      },
      [F]
    );
    s.useEffect(() => {
      const a = d.viewport;
      if (a) {
        const h = () => {
          I(S.current), n == null || n();
        }, C = () => {
          const k = (/* @__PURE__ */ new Date()).getTime() - g.current;
          S.current = S.current - k, window.clearTimeout(O.current), w == null || w();
        };
        return a.addEventListener(q, C), a.addEventListener(G, h), () => {
          a.removeEventListener(q, C), a.removeEventListener(G, h);
        };
      }
    }, [d.viewport, y, w, n, I]), s.useEffect(() => {
      l && !d.isClosePausedRef.current && I(y);
    }, [l, y, d.isClosePausedRef, I]), s.useEffect(() => (A(), () => j()), [A, j]);
    const $ = s.useMemo(() => i ? Ee(i) : null, [i]);
    return d.viewport ? /* @__PURE__ */ Q(se, { children: [
      $ && /* @__PURE__ */ c(
        Je,
        {
          __scopeToast: o,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: $
        }
      ),
      /* @__PURE__ */ c(ze, { scope: o, onClose: F, children: Ie.createPortal(
        /* @__PURE__ */ c(ee.ItemSlot, { scope: o, children: /* @__PURE__ */ c(
          De,
          {
            asChild: !0,
            onEscapeKeyDown: P(v, () => {
              d.isFocusedToastEscapeKeyDownRef.current || F(), d.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ c(
              D.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": l ? "open" : "closed",
                "data-swipe-direction": d.swipeDirection,
                ...N,
                ref: f,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: P(e.onKeyDown, (a) => {
                  a.key === "Escape" && (v == null || v(a.nativeEvent), a.nativeEvent.defaultPrevented || (d.isFocusedToastEscapeKeyDownRef.current = !0, F()));
                }),
                onPointerDown: P(e.onPointerDown, (a) => {
                  a.button === 0 && (m.current = { x: a.clientX, y: a.clientY });
                }),
                onPointerMove: P(e.onPointerMove, (a) => {
                  if (!m.current) return;
                  const h = a.clientX - m.current.x, C = a.clientY - m.current.y, k = !!T.current, V = ["left", "right"].includes(d.swipeDirection), H = ["left", "up"].includes(d.swipeDirection) ? Math.min : Math.max, Re = V ? H(0, h) : 0, Ne = V ? 0 : H(0, C), B = a.pointerType === "touch" ? 10 : 2, W = { x: Re, y: Ne }, oe = { originalEvent: a, delta: W };
                  k ? (T.current = W, U(Ye, E, oe, {
                    discrete: !1
                  })) : re(W, d.swipeDirection, B) ? (T.current = W, U(Xe, b, oe, {
                    discrete: !1
                  }), a.target.setPointerCapture(a.pointerId)) : (Math.abs(h) > B || Math.abs(C) > B) && (m.current = null);
                }),
                onPointerUp: P(e.onPointerUp, (a) => {
                  const h = T.current, C = a.target;
                  if (C.hasPointerCapture(a.pointerId) && C.releasePointerCapture(a.pointerId), T.current = null, m.current = null, h) {
                    const k = a.currentTarget, V = { originalEvent: a, delta: h };
                    re(h, d.swipeDirection, d.swipeThreshold) ? U(Be, R, V, {
                      discrete: !0
                    }) : U(
                      je,
                      M,
                      V,
                      {
                        discrete: !0
                      }
                    ), k.addEventListener("click", (H) => H.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        d.viewport
      ) })
    ] }) : null;
  }
), Je = (e) => {
  const { __scopeToast: t, children: o, ...r } = e, u = Y(K, t), [l, p] = s.useState(!1), [v, w] = s.useState(!1);
  return et(() => p(!0)), s.useEffect(() => {
    const n = window.setTimeout(() => w(!0), 1e3);
    return () => window.clearTimeout(n);
  }, []), v ? null : /* @__PURE__ */ c(Le, { asChild: !0, children: /* @__PURE__ */ c(ae, { ...r, children: l && /* @__PURE__ */ Q(se, { children: [
    u.label,
    " ",
    o
  ] }) }) });
}, Qe = "ToastTitle", fe = s.forwardRef(
  (e, t) => {
    const { __scopeToast: o, ...r } = e;
    return /* @__PURE__ */ c(D.div, { ...r, ref: t });
  }
);
fe.displayName = Qe;
var Ze = "ToastDescription", me = s.forwardRef(
  (e, t) => {
    const { __scopeToast: o, ...r } = e;
    return /* @__PURE__ */ c(D.div, { ...r, ref: t });
  }
);
me.displayName = Ze;
var ve = "ToastAction", we = s.forwardRef(
  (e, t) => {
    const { altText: o, ...r } = e;
    return o.trim() ? /* @__PURE__ */ c(ye, { altText: o, asChild: !0, children: /* @__PURE__ */ c(te, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${ve}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
we.displayName = ve;
var Te = "ToastClose", te = s.forwardRef(
  (e, t) => {
    const { __scopeToast: o, ...r } = e, u = qe(Te, o);
    return /* @__PURE__ */ c(ye, { asChild: !0, children: /* @__PURE__ */ c(
      D.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: P(e.onClick, u.onClose)
      }
    ) });
  }
);
te.displayName = Te;
var ye = s.forwardRef((e, t) => {
  const { __scopeToast: o, altText: r, ...u } = e;
  return /* @__PURE__ */ c(
    D.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...u,
      ref: t
    }
  );
});
function Ee(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), tt(r)) {
      const u = r.ariaHidden || r.hidden || r.style.display === "none", l = r.dataset.radixToastAnnounceExclude === "";
      if (!u)
        if (l) {
          const p = r.dataset.radixToastAnnounceAlt;
          p && t.push(p);
        } else
          t.push(...Ee(r));
    }
  }), t;
}
function U(e, t, o, { discrete: r }) {
  const u = o.originalEvent.currentTarget, l = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: o });
  t && u.addEventListener(e, t, { once: !0 }), r ? Oe(u, l) : u.dispatchEvent(l);
}
var re = (e, t, o = 0) => {
  const r = Math.abs(e.x), u = Math.abs(e.y), l = r > u;
  return t === "left" || t === "right" ? l && r > o : !l && u > o;
};
function et(e = () => {
}) {
  const t = X(e);
  Ve(() => {
    let o = 0, r = 0;
    return o = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(o), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function tt(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function ot(e) {
  const t = [], o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const u = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || u ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; o.nextNode(); ) t.push(o.currentNode);
  return t;
}
function z(e) {
  const t = document.activeElement;
  return e.some((o) => o === t ? !0 : (o.focus(), document.activeElement !== t));
}
var rt = ce, xe = de, ge = pe, he = fe, be = me, Pe = we, Ce = te;
const It = rt, st = _(({ className: e, ...t }, o) => /* @__PURE__ */ c(
  xe,
  {
    ref: o,
    className: L(
      "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
      e
    ),
    ...t
  }
));
st.displayName = xe.displayName;
const nt = Ke(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), at = _(({ className: e, variant: t, ...o }, r) => /* @__PURE__ */ c(ge, { ref: r, className: L(nt({ variant: t }), e), ...o }));
at.displayName = ge.displayName;
const it = _(({ className: e, ...t }, o) => /* @__PURE__ */ c(
  Pe,
  {
    ref: o,
    className: L(
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium transition-colors hover:bg-secondary focus:outline-none focus:ring-1 focus:ring-ring disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
      e
    ),
    ...t
  }
));
it.displayName = Pe.displayName;
const ct = _(({ className: e, ...t }, o) => /* @__PURE__ */ c(
  Ce,
  {
    ref: o,
    className: L(
      "absolute right-1 top-1 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-1 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ c(Se, { className: "size-4" })
  }
));
ct.displayName = Ce.displayName;
const ut = _(({ className: e, ...t }, o) => /* @__PURE__ */ c(
  he,
  {
    ref: o,
    className: L("text-sm font-semibold [&+div]:text-xs", e),
    ...t
  }
));
ut.displayName = he.displayName;
const dt = _(({ className: e, ...t }, o) => /* @__PURE__ */ c(be, { ref: o, className: L("text-sm opacity-90", e), ...t }));
dt.displayName = be.displayName;
export {
  It as T,
  st as a,
  at as b,
  ut as c,
  dt as d,
  ct as e,
  it as f
};
//# sourceMappingURL=toast-BRKBR_c0.js.map
